<template>
    <div>
        <TitleBar>
            <template v-slot:title><translate>Customer Insight</translate></template>
            <template v-slot:buttons>
                <GekkoButton 
                    :text="$gettext('All reports')"
                    :to="{ name: 'Reports' }"
                    icon="fa fa-chart-column"
                />
            </template>
        </TitleBar>
        <div class="content">
            <div v-if="!$store.getters['getIsPremium']" class="gk-tip gk-tip--warning gk-tip--caution my-4" :style="tipCssVars">
                <span v-translate>This report is based on fake data, please feel free to play with it and </span>
                <a href="/en/subscriptions/manage/">{{ $gettext("upgrade to premium.") }}</a>
            </div>
            <FilterBar
                cookieName="CustomerInsightFilterOptionsVue"
                :mainFilters="[ 'CustomerInsightReportSelector', 'DateRangeFilter']"
                filterBarType="customer-insight"
                @change="filtersChanged"
            >
            <template v-slot:right-bar>
                <TotalAmountsCustomer />
            </template>
            </FilterBar>

            <MarginTable v-show="selectedReport === 0" :customers="customers" :filters="filters" />

            <IncomeTable v-show="selectedReport === 1" :customers="customers" :filters="filters" />

            <InsightTripsTable v-show="selectedReport === 2" :customers="customers" :filters="filters" />

            <InsightHoursTable v-show="selectedReport === 3" :customers="customers" :filters="filters" />


        </div>
    </div>
</template>

<script>
import TitleBar from "@/components/TitleBar"
import GekkoButton from "@/components/GekkoButton"
import MarginTable from "@/components/customer_insight/MarginTable"
import IncomeTable from "@/components/customer_insight/IncomeTable"
import InsightTripsTable from "@/components/customer_insight/InsightTripsTable"
import InsightHoursTable from "@/components/customer_insight/InsightHoursTable.vue"
import CustomerService from "@/store/services/customer.service"
import FilterBar from "@/components/list_filters/FilterBar"
import TotalAmountsCustomer from "@/components/costs/TotalAmountsCustomer.vue"

export default {
    name: "CustomerInsight",
    components: { TitleBar, GekkoButton, MarginTable, InsightTripsTable, InsightHoursTable, FilterBar, TotalAmountsCustomer, IncomeTable },
    data() {
        return {
            customers: [],
            selectedReport: 0,
            filters: {}
        }
    },
    created() {
        CustomerService.list().then((response) => {
            this.customers = response.data
        })
    },
    methods: {
        filtersChanged(filters) {
            this.filters = JSON.parse(JSON.stringify(filters))

            if ('report_option' in filters && filters.report_option != null) {
                this.selectedReport = filters.report_option
            }
        }
    },
    computed: {
        tipCssVars() {
            return `--cautiontext: '${ this.$gettext('Gekko premium tip') }'`
        }
    }
}
</script>

<style scoped>

</style>